import { IConfigState } from '../../types/reducers/config';
import { createStaticReducer } from '../../../AppModulesWrapper/utils/redux/createStaticReducer';

export const config = createStaticReducer<IConfigState>();
